<template lang="pug">
    div
        v-select(
            class="style-chooser"
            :options="options" 
            :multiple="multiple"
            placeholder="Latency"
            :reduce="option => option.value"
            :value="$store.state.dashboard.queryFilter.latencyStatusNames"
            @input="updateValue"
        )
            template(slot="option" slot-scope="option")
                Icon(:color="option.color" type="ios-radio-button-on" size=16 style="margin: 5px")
                | {{ option.label }}
            span(slot="no-options") {{ $t('main.selectNotFoundText') }}
</template>

<script>
import { colorNames } from "@/libs/rcmTableFieldsFunction";

export default {
    name: "LatencyStatusNameSelector",
    components: {},
    props: {
        multiple: { type: Boolean, default: true }
    },
    watch: {},
    data() {
        return {
            options: [
                { label: "0-200", value: "0-200", color: colorNames.green },
                { label: "201-499", value: "201-499", color: colorNames.orange },
                { label: "500", value: "500", color: colorNames.red }
            ]
        };
    },
    computed: {},
    methods: {
        updateValue(value) {
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "latencyStatusNames", value: value });
        }
    },
    mounted() {},
    created() {},
    destroyed() {},
    beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/LatencyStatusNameSelector.vue